import { Controller } from '@hotwired/stimulus'
let timer = ''
export default class UserController extends Controller {
  static targets = ['confirmButton', 'customCheckbox', 'timepicker']

  connect() {
    if (this.hasCustomCheckboxTarget) {
      this.toggleTimepickers()
    }
  }

  updatePaymentType(event) {
    event.preventDefault()
    $(event.target).closest('form')[0].requestSubmit()
  }

  toggleButton(e) {
    const selected = e.target.value
    const button = this.confirmButtonTarget

    $('.delete-account').removeClass('disabled')

    if (selected === 'Delete') {
      $('.delete-account-options').removeClass('d-none')

      button.dataset.confirmationConfirmTextValue = 'Yes'
    } else {
      $('.delete-account-options').addClass('d-none')
      $('.delete-account-options input[type="checkbox"]').prop('checked', false)

      button.dataset.confirmationConfirmTextValue = 'Yes, deactivate it!'
    }
  }

  submitData(event) {
    $(event.target).closest('form')[0].requestSubmit()
  }

  addNotification(event) {
    $(event.target).closest('form')[0].requestSubmit()
  }

  removeData(e) {
    const $container = $(this.element)
      .closest('.analytics-page')
      .find('.interest-value')
    let interestId = $(this.element).prev('span').data('value')
    this.element.closest('.remove-interest').remove()
    $('select option[value=' + interestId + ']').prop('disabled', false)
    if ($container.children().length === 0) {
      $container.removeClass('d-flex').addClass('d-none')
    }
    let array_name = []
    $('.interest-name-value').each(function (index, element) {
      array_name.push($(element).attr('data-value'))
    })
    fetch('/connects?interest_name=' + array_name, {
      method: 'get',
      headers: {
        Accept: 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '',
        'Content-Type': 'application/json'
      }
    })
      .then((r) => r.text())
      .then((html) => {
        Turbo.renderStreamMessage(html)
      })
  }

  userSearch(e) {
    clearTimeout(timer)
    timer = setTimeout(function () {
      e.preventDefault()
      let form = $(e.target).closest('form')
      form[0].requestSubmit()
    }, 500)
  }

  closeMessageSearch(e) {
    const form = e.currentTarget.closest('.message_search_box')
    form.querySelector('.message-search').value = ''

    const url = new URL(globalThis.location.href)
    url.searchParams.delete('request')
    url.searchParams.delete('message')

    Turbo.visit(url.toString(), {
      frame: 'chat-area'
    })
  }

  showMoreAccounts(e) {
    const showMoreButton = $(e.currentTarget)
    const hiddenElements = showMoreButton
      .closest('.card-container')
      .find('.hiddenAccount')
    const hiddenElements1 = showMoreButton
      .closest('.bank-account-container')
      .find('.hiddenAccount')
    hiddenElements.removeClass('d-none')
    hiddenElements1.removeClass('d-none')
    showMoreButton.hide()
  }

  changeValue(e) {
    const value = Number.parseInt(e.target.value, 10)
    const scale =
      Number.parseInt(e.target.dataset.min) +
      value / Number.parseInt(e.target.dataset.divide || 1)
    document.documentElement.style.setProperty(e.target.dataset.property, scale)

    const sliderEl = e.target
    const isTextSize = sliderEl.classList.contains('text-size-slider')
    let tempSliderValue = Number.parseInt(sliderEl.value)
    if (isTextSize) {
      tempSliderValue = Math.floor(tempSliderValue / 2) * 2
    }
    sliderEl.value = tempSliderValue
    const progress = (tempSliderValue / sliderEl.max) * 100
    sliderEl.style.background = `linear-gradient(to right, #E85BF4 ${progress}%, #1EC92F ${progress}%)`
    this.updateSetting(e)
  }

  togglePrivacySafety(e) {
    e.preventDefault()
    const scheduleManuallyCheckbox = $('.schedule_manually_check_box')
    const privacySafetyDiv = $('.privacy-safety')
    const riseToSetCheckbox = $('.sunset_check_box')
    const customCheckbox = $('.custom_select')
    const turnOnOffDiv = $('.turn-on-off')
    if (scheduleManuallyCheckbox.prop('checked')) {
      privacySafetyDiv.removeClass('d-none')
      if (riseToSetCheckbox.prop('checked')) {
        turnOnOffDiv.removeClass('d-none')
      } else {
        turnOnOffDiv.addClass('d-none')
        customCheckbox.prop('checked', false)
      }
    } else {
      privacySafetyDiv.addClass('d-none')
      turnOnOffDiv.addClass('d-none')
      customCheckbox.prop('checked', false)
    }
    this.updateSetting(e)
  }

  toggleCustom(e) {
    e.preventDefault()
    const isCustom = $('.custom_select')
    const isRise = $('.sunset_check_box')
    const privacySafetyDiv = $('.turn-on-off')
    const form = $(e.target).closest('form')
    if ($(e.target).hasClass('custom_select')) {
      isRise.prop('checked', false)
      isCustom.prop('checked', true)
      privacySafetyDiv.removeClass('d-none')
    }
    if ($(e.target).hasClass('sunset_check_box')) {
      isRise.prop('checked', true)
      isCustom.prop('checked', false)
      privacySafetyDiv.addClass('d-none')
    }
    this.toggleTimepickers()
    form[0].requestSubmit()
  }

  toggleTimepickers() {
    const enabled = this.customCheckboxTarget.checked

    this.timepickerTargets.forEach((input) => {
      if (enabled) {
        $(input).rules("add", {
          required: true
        })

        if (input.dataset.ruleGreaterThan) {
          $(input).rules("add", {
            greaterThan: input.dataset.ruleGreaterThan
          })
        }
      } else {
        $(input).rules("remove", "required greaterThan")
      }
    })
  }

  updateSetting(event) {
    const input = event.target
    const form = input.form
    const token = document.querySelector('meta[name="csrf-token"]').content

    const formData = new FormData()
    if (input.type === "checkbox") {
      formData.append(input.name, input.checked ? "1" : "0")
    } else {
      formData.append(input.name, input.value)
    }

    fetch(form.action, {
      method: 'PUT',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': token
      },
      body: formData
    })
  }

  addRemoveTopics(e) {
    let id = $(this.element).attr('data-value')
    let type = $(this.element).attr('data-type')

    fetch('/topics/' + id + '/add_remove_topics?type=' + type, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '',
        Accept: 'text/vnd.turbo-stream.html',
        'Content-Type': 'application/json'
      }
    })
      .then((r) => r.text())
      .then((response) => {
        Turbo.renderStreamMessage(response)
      })
  }

  showMoreTopics(e) {
    Turbo.visit('/topics/?type=show_more')
  }

  interestChanged(event) {
    const select = event.target;
    const image = select.dataset.image;

    const $container = $(select)
      .closest(".analytics-page")
      .find(".interest-value");

    $container.empty();

    const values = $(select).val() || [];

    values.forEach((id) => {
      const name = $(select).find(`option[value="${id}"]`).text();

      const $el = $(`
        <div class="remove-interest position-relative d-flex align-items-center justify-content-center px-5 py-1">
          <img class="img img-fluid position-absolute" src="${image}">
          <span
            class="text-white-paint text-black interest-name-value text-center d-inline-block p-font-bold fs-16 position-relative"
            data-value="${id}">
            ${name}
          </span>
          <button
            type="button"
            class="position-relative btn p-0 fs-20 fw-bold scale-hover"
            data-id="${id}">
            <i class="ri-close-fill"></i>
          </button>
        </div>
      `);

      $el.find("button").on("click", (e) => this.removeInterest(e));

      $container.append($el);
    });

    if (values.length) {
      $container.removeClass("d-none").addClass("d-flex");
    } else {
      $container.addClass("d-none").removeClass("d-flex");
    }
  }

  removeInterest(event) {
    const id = event.currentTarget.dataset.id;
    const select = this.element.querySelector('[data-action~="change->user#interestChanged"]');
    const $container = $(this.element).closest(".analytics-page").find(".interest-value");

		$container.find(`.interest-name-value[data-value="${id}"]`).closest('.remove-interest').remove();

    let values = $(select).val() || [];
    values = values.filter((value) => value !== id);

    $(select).val(values).trigger('change');
    this.fetchInterestData(select);
  }

  fetchInterestData(select) {
    $(".select2-selection__choice").remove();
    $(".select2-search__field").attr("placeholder", "Select Interest").removeAttr("style");
    select.closest("form").requestSubmit();
  }
}
